import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  search: '',
}

const messageSearchSlice = createSlice({
  name: 'messageSearch',
  initialState,
  reducers: {
    setValue(state, action) {
      state.search = action.payload
    },
    clearValue(state) {
      state.search = ''
    },
  },
})

export const { setValue, clearValue } = messageSearchSlice.actions
export default messageSearchSlice.reducer
